<template>
  <v-card outlined class="mb-3">
    <v-card-subtitle class="d-flex align-center pb-2">
      <v-icon small color="primary" class="mr-2">mdi-package-variant-closed</v-icon>
      <span class="font-weight-bold primary--text">{{ $t("package") }}</span>
    </v-card-subtitle>
    <v-card-text>
      <v-switch
        v-model="editedItem.is_package"
        :label="$t('package')"
        color="primary"
        inset
        dense
        hide-details
        class="mt-0"
      ></v-switch>

      <template v-if="editedItem.is_package">
        <v-alert type="info" text dense outlined class="mt-4 mb-3">
          {{ $t("food_package.reminder") }}
        </v-alert>
        <v-row dense>
          <v-col cols="12" sm="6">
            <text-field
              v-model="editedItem.package_min_items"
              type="number"
              :label="$t('food_package.min_items')"
              :hint="$t('food_package.empty_means_no_rule')"
              persistent-hint
            ></text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <text-field
              v-model="editedItem.package_max_items"
              type="number"
              :label="$t('food_package.max_items')"
              :hint="$t('food_package.max_items_hint')"
              :rules="maxRules"
              persistent-hint
            ></text-field>
          </v-col>
        </v-row>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
const isEmpty = (value) => value === null || value === undefined || value === "";

export default {
  name: "FoodPackage",
  props: {
    editedItem: {
      type: Object,
      required: true,
    },
  },
  computed: {
    maxRules() {
      return [
        () => {
          const min = this.editedItem.package_min_items;
          const max = this.editedItem.package_max_items;
          if (isEmpty(min) || isEmpty(max)) {
            return true;
          }
          return Number(min) <= Number(max) || this.$t("food_package.min_gt_max");
        },
      ];
    },
  },
};
</script>
